import { ReactElement } from 'react'
import AnchorOutlined from '@mui/icons-material/AnchorOutlined'
import Results2ElementList, { Results2ListItem } from '../Results2ElementList'

/** The anchors list's `qs` column holds the chosen anchor product, not a cross section. */
const ANCHOR_QS_SORT_OPTION = { label: 'Nach gewähltem Anker', icon: AnchorOutlined }

type Props = {
  items: Results2ListItem[]
  selectedId?: string
  selectedIds?: string[]
  onSelect?: (id: string) => boolean | void
  onSelectionChange?: (ids: string[]) => boolean | void
  isLoading?: boolean
  emptyMessage?: string
  onCalculate?: () => void
  /** Cancels in-flight results loading; surfaced as an "Abbrechen" footer button. */
  onAbort?: () => void
  /** When true, shows the "Abbrechen" button next to "Berechnen". */
  showAbort?: boolean
  fokusCamera: boolean
  onFokusCameraChange: (next: boolean) => void
  fokusTransparency: boolean
  onFokusTransparencyChange: (next: boolean) => void
  disableForm?: boolean
}

/**
 * Overview list of the "Anker" wall sub-tab: compact rows (one per tensile anchor) with the
 * comment column enabled. Comment edits autosave through the manual-loads endpoint; anchors have
 * no Vorbemerkungen, so only the single comment sub-column is shown. The list-toggle and
 * multi-select modifiers select several anchors at once, which opens the multi-edit pane.
 */
const Results2AnchorsList = ({
  items,
  selectedId,
  selectedIds,
  onSelect,
  onSelectionChange,
  isLoading,
  emptyMessage,
  onCalculate,
  onAbort,
  showAbort = false,
  fokusCamera,
  onFokusCameraChange,
  fokusTransparency,
  onFokusTransparencyChange,
  disableForm = false,
}: Props): ReactElement => {
  return (
    <Results2ElementList
      items={items}
      elementType="standard_rips"
      selectedId={selectedId}
      selectedIds={selectedIds}
      onSelect={onSelect}
      onSelectionChange={onSelectionChange}
      multiSelectEnabled
      groupingEnabled={false}
      isLoading={isLoading}
      emptyMessage={emptyMessage}
      showBlockpadButton={false}
      onCalculate={onCalculate}
      onAbort={onAbort}
      showAbort={showAbort}
      showCommentColumn
      showExtendedCommentColumn={false}
      commentPlaceholder="Kommentar..."
      commentSuggestionKind="anchor"
      metricSortLabel="Nach Design-Zuglast"
      etaCSortEnabled={false}
      qsSortOption={ANCHOR_QS_SORT_OPTION}
      qsFilterKind="anchor"
      anchorCommentAutosave
      hideExportButton
      fokusCamera={fokusCamera}
      onFokusCameraChange={onFokusCameraChange}
      fokusTransparency={fokusTransparency}
      onFokusTransparencyChange={onFokusTransparencyChange}
      disableForm={disableForm}
    />
  )
}

export default Results2AnchorsList
